import Vue from 'vue'
import {CONFIG} from './config.js'

const ShiftDetail = Vue.component('shift_detail', {
    props: ['id'],
    template: '#shift_detail',
    data: function() {
        return {
            selectedFrom: null,
            selectedTo: null,
            timeOptionsStep: 15, // in minutes
            person: {},
            photo: null,
            showConfirm: false,
            shiftButtons: []
        }
    },
    mounted: function() {
        if (this.shift == null) {
            return;
        }

        this.selectedFrom = this.shift.shift_time_from;
        this.selectedTo = this.shift.shift_time_until;

        this.$ebus.$emit('menu:update', {component: 'menu-detail', data: {person_name: this.shift.person_name}});

        var self = this;

        this.$ebus.$emit("ajax:start");

        this.$protected("get", CONFIG.api.endpoints.person,
            function(r) {
                self.person = r.data[0];
            },
            {
                params: {
                    person_id: "eq." + this.shift.person_id
                }
            });

            this.$protected("get", CONFIG.api.endpoints.shiftButtons,
            function(r) {
                self.shiftButtons = r.data;
            },
            {
                params: {
                    department_id: "eq." +  this.shift.department_id,
                    work_type_id: "eq." + this.shift.work_type,
                }
            });
    },
    watch: {
        person: function(value) {
            if (this.isEmpty(value)) {
                return;
            }

            var self = this;

            // photo
            this.$protected("post", CONFIG.api.endpoints.photo,
                function(r) {
                    // empty string is needed for watcher triggering, null doesn't trigger it
                    self.photo = r.data ? self.hexToBase64(r.data) : "";
                },
                {
                    data: {
                        photo_: this.person.photo
                    }
                })
        },
        photo: function(value) {
            this.$ebus.$emit("ajax:finished");
        },
        selectedFrom: function(value) {
            this.updateWorkedAndPaid();
        },
        selectedTo: function(value) {
            this.updateWorkedAndPaid();
        }
    },
    destroyed: function() {
        this.$ebus.$emit('menu:reset');
    },
    computed: {
        shift: {
            get: function() {
                return this.$store.getters.getShiftById(this.id);
            },
            set: function(value) {
                this.$store.commit('updateShiftById', { id: this.id, data: value });
            }
        },
        shiftId: function() {
            return this.shift.ord_shift_id;
        },
        shiftVersion: function() {
            return this.shift.objversion;
        },
        shiftWorked: function() {
            var from = this.parseShiftDateTime(this.selectedFrom);
            var to = this.parseShiftDateTime(this.selectedTo);

            return this.$moment.duration(to.diff(from)); // + (from.getTimezoneOffset() * 60 * 1000) * 2;
        },
        timeOptions: function() {
            var dt = this.parseShiftDateTime("00:00:00");
            var day = dt.date();

            var options = [];
            while (true) {
                options.push(dt.clone());

                dt.add(this.timeOptionsStep, "minutes");
                if (dt.date() != day) {
                    break;
                }
            }

            return options;
        },
        hoursWorked: function() {
            return this.$moment.duration(this.shift.shift_hour, "hours");
        },
        hoursPaid: function() {
            return this.$moment.duration(this.shift.hour_paid, "hours");
        },
        hoursBreak: function() {
            return this.hoursWorked.subtract(this.hoursPaid);
        }
    },
    methods: {
        parseShiftDateTime: function (time) {
            return this.$moment(this.shift.shift_date + " " + time, "YYYY-MM-DD HH:mm:ss");
        },
        shiftApprove: function() {
            this.updateShift('APPROVED');
        },
        shiftAbsence: function() {
            this.updateShift('ABSENCE');
        },
        shiftExcuse: function() {
            this.updateShift('EXCUSED');
        },
        shiftUnapprove: function() {
            this.updateShiftState('UNAPPROVED');
        },
        updateShiftState: function(status) {
            var self = this;

            this.$updateShiftState(this.shiftId, this.shiftVersion, status,
                function (r) {
                    self.shift = r.data[0];
                });
        },
        updateShift: function(status) {
            var self = this;

            this.$updateShift(this.shiftId, this.shiftVersion,
                {
                    shift_date: this.shift.shift_date,
                    shift_time_from: this.selectedFrom,
                    shift_time_until: this.selectedTo,
                    shift_state_simple:  status || 'APPROVED'
                },
                function (r) {
                    self.shift = r.data[0];
                });
        },
        submit: function(e) {
            this.updateShift();
            e.preventDefault();
        },
        reset: function() {
            this.selectedFrom = this.shift.shift_time_from;
            this.selectedTo = this.shift.shift_time_until;
        },
        isEmpty: function(o) {
            return o == null || !Object.keys(o).length
        },
        hexToBase64: function(str) {
            if (str == null) {
                return null;
            }

            // string begins with \x (hex format prefix)
            var hex = str.trim().substring(2)
                .replace(/\r|\n/g, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ");

            return btoa(String.fromCharCode.apply(null, hex));
        },
        updateWorkedAndPaid: function() {
            var self = this;

            this.$protected("post", CONFIG.api.endpoints.hoursPaid,
                function(r) {
                    self.shift.shift_hour = r.data[0];
                    self.shift.hour_paid = r.data[0] - r.data[1];
                },
                {
                    data: {
                        department_id_: this.shift.department_id,
                        shift_time_from_: this.selectedFrom,
                        shift_time_until_: this.selectedTo
                    }
                });
        }
    }
})

export default ShiftDetail;